// Constant giới hạn của Number
export default {
  Min: 0, // Giá trị tối thiểu cho phần số với giá trị nhỏ nhất là 0
  Max: 99999999999999, // Giá trị tối đa cho số lượng
  MinNegative: -99999999999999, // Giá trị tối thiểu cho số lượng với trường hợp được nhập số âm
  TotalMax: 999999999999999999, // Giá trị tối đa cho tổng số lượng 
  ToTalMin: -999999999999999999, // Giá trị tối thiểu cho tổng số lượng
  MaxAmount: 99999999999999, // Giá trị tối đa cho số tiền 
  MinAmount: -99999999999999, // Giá trị tối thiểu cho tổng số tiền
  MinZeroAmount: 0, // Số tiền tối thiểu 0
  MaxCountNumber: 14, 
  MinPercentage: 0, // Giá trị phần trăm nhỏ nhất
  MaxPercentage: 100, // Giá trị phần trăm lớn nhất
};
